import { CalendarViewCellHeight } from '@repo/lib/constants/calendar-constants';
import { VIEW_KEY } from '@repo/types/enums/viewKey';
import { useCallback, useEffect, useRef } from 'react';

export function useCalendarScrollView(view: VIEW_KEY) {
  const ref = useRef<HTMLDivElement>(null);

  const scrollToCurrentTime = useCallback(() => {
    if ((view === VIEW_KEY.WEEK || view === VIEW_KEY.DAY) && ref.current) {
      const now = new Date();
      const currentHour: number = now.getHours();
      const currentMinute: number = now.getMinutes();

      const hourPosition: number = currentHour * CalendarViewCellHeight;
      const minutePosition: number = (currentMinute / 60) * CalendarViewCellHeight;
      const totalPosition: number = hourPosition + minutePosition;

      const scrollPosition: number = Math.max(0, totalPosition - CalendarViewCellHeight);

      ref.current.scrollTo({
        top: scrollPosition,
        behavior: 'instant',
      });
    }
  }, [view]);

  useEffect(() => {
    scrollToCurrentTime();
  }, [scrollToCurrentTime]);

  return { ref, scrollToCurrentTime };
}
